export default __webpack_public_path__ + "e12bc7ea244fee32d870f88589c8283a.svg";